/* eslint-disable react/no-unused-state */
import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Formik, Form, Field } from "formik";
import { bool, string, func } from "prop-types";
import * as Yup from "yup";
import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import { selectors as loginSelectors, actions as loginActions } from "reducers/login";
import * as i18n from "util/i18n";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import { Mixpanel } from "util/clickstreaming";
import { push } from "connected-react-router";
import HideInput from "pages/_components/fields/credentials/HideInput";

const FORM_ID = "login.step1";

class UserForm extends Component {
    formikProps = {
        enableReinitialize: true,
        validateOnChange: false,
        validateOnBlur: false,
        initialValues: {
            username: "",
            usernameSecret: "",
        },
        validationSchema: () => {
            const {
                isVerifyUserCredentialsForm,
                onboardingWithInvitation,
                isActiveEnvironmentUsersListEmpty,
            } = this.props;
            return Yup.object().shape({
                username:
                    !isVerifyUserCredentialsForm || !onboardingWithInvitation
                        ? Yup.number().required(i18n.get("onboarding.step4.username.error.empty"))
                        : Yup.number().notRequired(),
                usernameSecret: isActiveEnvironmentUsersListEmpty
                    ? Yup.string().required(i18n.get("user.disabled.validation.error.message"))
                    : Yup.string().required(i18n.get("recoveryPassword.step1.username.required")),
            });
        },
        onSubmit: ({ username, rememberEmail, usernameSecret }) => {
            Mixpanel.identify(username);
            Mixpanel.track(FORM_ID, { rememberEmail });
            const { isVerifyUserCredentialsForm, dispatch } = this.props;
            if (isVerifyUserCredentialsForm) {
                dispatch(onboardingActions.verifyUserCredentialsStep1(username, usernameSecret));
            } else {
                dispatch(loginActions.loginStep1(username, rememberEmail, usernameSecret));
            }
        },
    };

    static propTypes = {
        isDesktop: bool.isRequired,
        isFetching: bool.isRequired,
        className: string,
        dispatch: func.isRequired,
        isVerifyUserCredentialsForm: bool,
        onboardingWithInvitation: bool.isRequired,
        isActiveEnvironmentUsersListEmpty: bool.isRequired,
    };

    static defaultProps = {
        className: "",
        isVerifyUserCredentialsForm: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            showCuilForm: true,
        };
        this.formRef = React.createRef();
    }

    componentDidMount() {
        const { isVerifyUserCredentialsForm, onboardingWithInvitation } = this.props;

        this.setState({
            showCuilForm: !isVerifyUserCredentialsForm || !onboardingWithInvitation,
        });
    }

    componentDidUpdate(prevProps) {
        const { isActiveEnvironmentUsersListEmpty } = this.props;
        if (
            prevProps.isActiveEnvironmentUsersListEmpty !== isActiveEnvironmentUsersListEmpty &&
            isActiveEnvironmentUsersListEmpty
        ) {
            this.formRef.current.setFieldError(
                "usernameSecret",
                i18n.get("user.disabled.validation.error.message", "Tu usuario no está habilitado"),
            );
        }
    }

    handleClickModalForgotUser = () => {
        const { dispatch } = this.props;
        dispatch(push("/recovery/username/step1"));
    };

    render() {
        const { isDesktop, isFetching, className, isVerifyUserCredentialsForm } = this.props;
        const { showCuilForm } = this.state;
        return (
            <Formik {...this.formikProps} ref={this.formRef}>
                {() => (
                    <Form className={className} noValidate="novalidate" ref={this.formRef} autoComplete="off">
                        {showCuilForm && (
                            <Field
                                idForm={FORM_ID}
                                name="username"
                                component={TextField}
                                labelText="administration.channels.cuil"
                                autoFocus={isDesktop}
                                onlyNumbers
                            />
                        )}
                        <input type="text" name="fakeuser" autoComplete="off" style={{ display: "none" }} />
                        <Field
                            idForm={FORM_ID}
                            name="usernameSecret"
                            component={HideInput}
                            labelText="administration.channels.usernameSecret"
                            autoFocus={isDesktop}
                            autoComplete="off"
                            autoCorrect="off"
                            spellCheck="false"
                            aria-autocomplete="none"
                        />
                        <Button
                            type="submit"
                            bsStyle="primary"
                            label="global.continue"
                            loading={isFetching}
                            block
                            className="mt-4"
                        />
                        {!isVerifyUserCredentialsForm && (
                            <Button
                                bsStyle="link"
                                onClick={this.handleClickModalForgotUser}
                                label="onboarding.forgotUser"
                            />
                        )}
                    </Form>
                )}
            </Formik>
        );
    }
}

const mapStateToProps = (state) => ({
    isFetching: loginSelectors.getFetching(state),
    onboardingWithInvitation: onboardingSelectors.getOnboardingWithInvitation(state),
    isActiveEnvironmentUsersListEmpty: loginSelectors.getIsActiveEnvironmentUsersListEmpty(state),
});

export default compose(connect(mapStateToProps))(UserForm);
